import { batchImportBudgetCompileLib, getBudgetEpProjectPoolAuditList } from '../services';

export default {
  namespace: 'projectReserveAudit',
  state: {},
  effects: {
    // 项目储备审核列表
    *getBudgetEpProjectPoolAuditList({ payload }, { call }) {
      return yield call(getBudgetEpProjectPoolAuditList, payload);
    },

    // 批量导入预算编制库
    *batchImportBudgetCompileLib({ payload }, { call }) {
      return yield call(batchImportBudgetCompileLib, payload);
    },
  },
  reducers: {
    update(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
